"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Nov 12 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemConverter.
 *
 * @author JMt
 */


var WindowItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemConverter, _DataObjectConverter_);

  function WindowItemConverter() {
    _classCallCheck(this, WindowItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemConverter).apply(this, arguments));
  }

  return WindowItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemConverter = WindowItemConverter;